module.exports = __webpack_public_path__ + "static/scale-model-of-iowa-tourism-office-in-des-moines-iowa-08ce18ae87b23844ff2f2a170fe1cbd7.png";